import { render, staticRenderFns } from "./ResultPanel.vue?vue&type=template&id=8d798a72&scoped=true&"
import script from "./ResultPanel.vue?vue&type=script&lang=ts&"
export * from "./ResultPanel.vue?vue&type=script&lang=ts&"
import style0 from "./ResultPanel.vue?vue&type=style&index=0&id=8d798a72&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d798a72",
  null
  
)

export default component.exports